import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
export function checkMobilePhone(raw) {
    const text = raw.trim();
    // Integration contracts carry E.164 only: a number without its country code
    // is refused instead of guessed.
    if (!/^\+[1-9]\d{7,14}$/.test(text))
        return { ok: false, problem: 'PHONE_INVALID' };
    const parsed = parsePhoneNumberFromString(text);
    if (!parsed?.isValid())
        return { ok: false, problem: 'PHONE_INVALID' };
    const type = parsed.getType();
    // FIXED_LINE_OR_MOBILE is a known library limitation of numbering plans
    // such as +1 where mobile and fixed ranges coincide; it is never returned
    // for Jordan, whose landlines are FIXED_LINE.
    if (type === 'MOBILE' || type === 'FIXED_LINE_OR_MOBILE') {
        return { ok: true, e164: parsed.number };
    }
    return { ok: false, problem: 'PHONE_NOT_MOBILE' };
}
//# sourceMappingURL=phone.js.map